<wms-dialog-header
title="{{ locale['LABEL_PREFAB_VERSION_MISMATCH_TITLE']}}" (onClose)="closeDialog()"></wms-dialog-header>
<wms-dialog-body>
    <wms-message [scopeDataset]="message"></wms-message>
<p class="app-dialog-body-title" [innerHTML]="locale.MESSAGE_PREFAB_VERSION_CONFLICT.replace('${0}', [
prefabName
])">
</p>
<p>{{locale.MESSAGE_PREFAB_VERSION_CONFLICT_RESOLUTION}}</p>
<table class="wm-table">
    <colgroup>
        <col width="200"/>
        <col width="200"/>
        <col width="200"/>
        <col/>
    </colgroup>
    <thead>
    <tr>
        <th>{{locale.LABEL_PREFAB}}</th>
        <th>{{locale.LABEL_VERSION}} <i class="text-muted">{{locale.LABEL_IN_PROJECT}}</i></th>
        <th>{{locale.LABEL_VERSION}} <i class="text-muted">{{locale.LABEL_CAUSING_CONFLICT}}</i></th>
        <th>{{locale.LABEL_DEPENDENCY_TYPE}}</th>
    </tr>
    </thead>
</table>
<div  class="change-table-container">
    <table class="wm-table">
        <colgroup>
            <col width="200"/>
            <col width="200"/>
            <col width="200"/>
            <col/>
        </colgroup>
        <tbody>
            <tr *ngFor="let prefab of conflictPrefabs">
                <td><span>{{prefab.prefabName}}</span></td>
                <td>
                    <span>{{prefab.previousReadableVersion ? prefab.previousReadableVersion+'('+prefab.previousVersion+')' : prefab.previousVersion}}</span>
                    <p>
                        <span class="text-muted">{{locale.LABEL_ARTIFACT_PUBLISHED_BY}} : </span>
                        <span [ngClass]="{'text-muted' : !prefab.previousVersionBy}">{{prefab.previousVersionBy || 'NA'}}</span>
                    </p>
                </td>
                <td>
                    <span>{{prefab.toBeUpdatedReadableVersion ? prefab.toBeUpdatedReadableVersion+'('+prefab.toBeUpdatedVersion+')' : prefab.toBeUpdatedVersion}}</span>
                    <p>
                        <span class="text-muted">{{locale.LABEL_ARTIFACT_PUBLISHED_BY}} : </span>
                        <span [ngClass]="{'text-muted' : !prefab.toBeUpdatedVersionBy}">{{prefab.toBeUpdatedVersionBy || 'NA'}}</span>
                    </p>
                </td>
                <td class="dependent-prefab">
                    <p *ngIf="prefab.isUsedByProject">{{locale.LABEL_USED_BY_PROJECT}}.</p>
                    <p *ngIf="prefab.usedByPrefabs.length"> {{locale.LABEL_USED_BY_PREFABS}}: {{prefab.usedByPrefabs}}.</p>
                </td>
            </tr>
        </tbody>
    </table>
</div>
</wms-dialog-body>
<wms-dialog-footer>
<button class="btn button-secondary app-button"
    (click)="skipConflict()">{{locale['LABEL_SKIP']}}</button>
<button class="btn btn-primary" (click)="onForceRegister()">{{locale['LABEL_PROCEED_ANYWAY']}}</button>
</wms-dialog-footer>
